import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Вы уверены, что хотите это удалить?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, { onOnsuccess: _ctx.deleteItem }, {
    title: _withCtx(() => [
      _createElementVNode("p", null, "Удаление раздела " + _toDisplayString(_ctx.title.value), 1)
    ]),
    content: _withCtx(() => [
      _hoisted_1
    ]),
    acceptButton: _withCtx(() => [
      _createTextVNode("Удалить")
    ]),
    _: 1
  }, 8, ["onOnsuccess"]))
}